import { useLayoutEffect } from 'react';
import { useMisbehavedForceUpdate } from '@visiba/react-std';
import { useService } from '@visiba/instantiation';
import { ReadonlyUser, AuthService } from './auth.service';

export function useUser(): ReadonlyUser | null {
	const authService = useService(AuthService);
	const update = useMisbehavedForceUpdate();

	useLayoutEffect(() => {
		const [subscriber] = authService.provideSubscription();

		return subscriber(() => {
			update();
		});
	}, [authService, update]);

	return authService.getUser();
}
